import { Link } from "react-router-dom";
import styled from "styled-components";

export const MainContainer = styled.section`
  width: 95%;
  margin: 90px auto 0;
  @media screen and (max-width: 768px) {
    margin-top: 50px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AccentBar = styled.span`
  width: 10px;
  height: 34px;
  border-radius: 3px;
  background: #e8521a;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  color: #111;
  font-family: Poppins;
  font-size: 28px;
  font-weight: 700;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const TabsWrap = styled.div`
  display: flex;
  gap: 4px;
  border: 1px solid #ebebeb;
  border-radius: 9px;
  background: #fff;
  padding: 4px;
`;

export const Tab = styled(Link)`
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #6b7280;
  font-size: 12px;
  padding: 6px 12px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  &.active {
    background: #e8521a;
    color: #fff;
  }
  &[aria-disabled="true"] {
    pointer-events: none;
    opacity: 0.6;
  }
`;

export const ViewAllLink = styled(Link)`
  color: #e8521a;
  font-size: 12px;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

export const ViewAllButton = styled.button`
  color: #e8521a;
  font-size: 12px;
  text-decoration: none;
  font-weight: 600;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

export const EmptyGridMessage = styled.p`
  margin: 24px 0 0;
  padding: 32px 20px;
  text-align: center;
  border-radius: 12px;
  border: 1px dashed #e5e7eb;
  background: #fafafa;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BentoGrid = styled.div`
  margin-top: 18px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 14px;
  min-height: 420px;
  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    min-height: 320px;
  }
`;

const baseCard = `
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  min-height: 236px;
  background-size: cover;
  background-position: center;
  text-decoration: none;
  color: inherit;
  display: block;
`;

export const MainCard = styled.article`
  ${baseCard};
  grid-row: 1 / 3;
  min-height: 500px;
  padding: 28px;
  background: ${({ $image }) =>
    $image ? `url(${$image}) center/cover no-repeat, linear-gradient(135deg,#0a0f1e,#111)` : "linear-gradient(135deg,#0a0f1e,#111)"};
`;

export const TopRightCard = styled.article`
  ${baseCard};
  cursor: default;
  padding: 24px;
  background: linear-gradient(135deg, #0f1628, #0a0a0a);
`;

export const SmallCard = styled.article`
  ${baseCard};
  padding: 20px;
  background: ${({ $image }) =>
    $image
      ? `url(${$image}) center/cover no-repeat, linear-gradient(135deg,#1a0a12,#111)`
      : "linear-gradient(135deg,#1a0a12,#111)"};
`;

export const CardOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.88) 0%, rgba(0, 0, 0, 0.32) 55%, transparent 100%);
`;

export const CardContent = styled.div`
  position: relative;
  z-index: 2;
  margin-top: auto;
`;

export const BadgeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

export const Badge = styled.span`
  font-size: 9px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #fff;
  background: rgba(255, 255, 255, 0.13);
  border: 1px solid rgba(255, 255, 255, 0.18);
  &.new {
    background: #e8521a;
    border-color: #e8521a;
  }
  &.hot {
    background: rgba(255, 100, 0, 0.9);
    border-color: rgba(255, 100, 0, 0.9);
  }
  &.trend {
    background: rgba(34, 197, 94, 0.9);
    border-color: rgba(34, 197, 94, 0.9);
  }
`;

export const StyledTitle = styled.h4`
  margin: 0;
  color: #fff;
  font-family: Poppins;
  font-weight: 700;
  line-height: 1.2;
  &.lg {
    font-size: 26px;
    margin-bottom: 6px;
  }
  &.md {
    font-size: 19px;
    margin-bottom: 5px;
  }
  &.sm {
    font-size: 15px;
    margin-bottom: 4px;
  }
`;

export const StyledSubTitle = styled.p`
  margin: 0 0 14px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.62);
  font-weight: 300;
  line-height: 1.5;
  &.md,
  &.sm {
    margin-bottom: 10px;
  }
`;

export const MetricRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MetricValue = styled.span`
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  &.blue {
    color: #60a5fa;
  }
  &.green {
    color: #22c55e;
  }
`;

export const MetricLabel = styled.span`
  margin-top: 2px;
  color: rgba(255, 255, 255, 0.45);
  font-size: 9px;
  text-transform: uppercase;
`;

export const StatDivider = styled.span`
  width: 1px;
  height: 28px;
  background: rgba(255, 255, 255, 0.1);
`;

export const SupplierMeta = styled.p`
  margin: 0 0 14px;
  color: rgba(255, 255, 255, 0.54);
  font-size: 10px;
  span {
    color: #22c55e;
    font-weight: 600;
  }
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
`;

const importButtonStyles = `
  border: 0;
  border-radius: 8px;
  background: #e8521a;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 9px 14px;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  text-align: center;
  font-family: inherit;
  &.sm {
    font-size: 11px;
    padding: 8px 12px;
  }
  &.ghost {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.14);
  }
`;

export const ImportButton = styled.button`
  ${importButtonStyles};
`;

export const ImportLink = styled(Link)`
  ${importButtonStyles};
`;

export const ImportLabel = styled.span`
  ${importButtonStyles};
  pointer-events: none;
`;

export const CountPill = styled.div`
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.55);
  margin-bottom: 8px;
`;

export const CategoryChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 14px;
`;

export const CategoryChip = styled(Link)`
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  font-size: 10px;
  padding: 4px 10px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  &.active {
    background: rgba(232, 82, 26, 0.15);
    border-color: rgba(232, 82, 26, 0.35);
    color: #e8521a;
  }
`;
